function HeaderServices() {
    return (
        <div className="header-services">
            <div className="overlay"></div>
            <div className="container">
                <div className="row">
                    <div className="col-12 header-content">
                        <div>
                            <h1>Services</h1>
                            <span>Home - Service page</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HeaderServices;